import {format} from 'date-fns';
import Long from 'long';

import unixDate from './unixDate';

export default function formatUnix(stamp?: Long | null, formatStr: string = ''): string {
  return format(unixDate(stamp), formatStr);
}